<template>
	<section>
		<!--Toolbar -->
		
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">        
				<el-form-item style='float:right' >
					<el-button type="primary" icon='el-icon-search' size='small' v-on:click="getRecords()">Refresh</el-button>
				</el-form-item>
        
			</el-form>
		</el-col>
    
    <!--Lijst-->
		<el-table :data="content" stripe highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column prop="name" label="LogName" min-width="120" sortable></el-table-column>
      <el-table-column prop="mod" label="Created" min-width="120" sortable></el-table-column>

			<el-table-column label="" width="100" fixed='right'>
				<template slot-scope="scope">
					<el-button type='success' size="small" icon="el-icon-view"  @click="handleView(scope.row)"></el-button>
					<el-button type="danger" size="small" icon="el-icon-delete"  @click="handleDel(scope.row)"></el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- Toolbar -->
		
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev,pager,next,jumper,sizes" @current-change="selectPage" :total="mainTotal" style="float:right;"
                     :page-sizes="[10, 15, 25, 50, 100]" @size-change="selectPagesize" :page-size="pageSize"></el-pagination>
      <span style='font-size:80%;margin:9px;float:right'>{{mainTotal}} records found</span>
      </el-col>
    
		<!--Wijzig record -->
		<el-dialog title="View Log" :visible.sync="editFormVisible" width='90%' :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-tabs type="card">
          <!-- -------------------------------------------------------------------------------------- -->
				  <el-tab-pane>
            <span slot='label'><i class='el-icon-date'></i> XLog</span>
           <el-form-item label="Name : ">
              <el-input disabled v-model="editForm['name']" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="Created : ">
              <el-input disabled v-model="editForm['mod']" auto-complete="off"></el-input>
            </el-form-item>
              <el-input readonly type='textarea' rows='15' v-model="text"></el-input>

  				</el-tab-pane>
				</el-tabs>
			</el-form>

			<div slot="footer" class="dialog-footer">		  
				<el-button size='small' icon="el-icon-upload2"  @click.native="editFormVisible = false">{{lang.butCancel}}</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
  import settings from '../../common/AppSettings';
 	import util     from '../../common/AppUtil';
  import text     from '../../common/AppText';
  import api      from '../../api/system/xlog';

	export default {
		data() {
			return {
        QID         : util.Initialize(this.$router,"XLG"),
        util        : util,
        stack       : {},
			  lang        : text.data,
        codes       : util.codes,
				pageSize    : settings.pageSize,
 		  	serverPaging: false,
        group       : "",
				editTitle   : "",
				editMode    : "",
				APICode     : "XLog",
				mainFunc    : "XLog",
				mainSubject : "log",
        mainKey     : "name",
				mainKeyDesc : "name",
        searchFilter: '',				
      
        content: [],
        text: "",
				currentPage: 1,
				mainTotal: 0,
		
				listLoading: false,
				editFormVisible: false,// Of de bewerkingsinterface wordt weergegeven
				editLoading: false,
				editForm: {},			
				editFormRules: {
					code: [
						{ required: true, message: text.data.mandatory, trigger: 'blur' }
					]
				},

			}
		},
		
		methods: {
 	  	closeForm: function () {
         this.selectorVisible = false;
	  		this.$router.push({name: 'Employees',params: this.stack});
    	},


		  openGroup: function() {
        this.content = [];        
        this.getRecords();
      },
    // paginering wissel, reload page			
		  selectPagesize: function(size) {
				settings.pageSize = size;
				this.showPagedData();
			},
			selectPage: function(page) {
				this.currentPage = page;								
				this.showPagedData();
			},
			showPagedData: function() {
				if (this.serverPaging) this.getRecords();
				else this.content = this.contentSaved.slice((this.currentPage - 1) * 
				                    settings.pageSize,this.currentPage * settings.pageSize);
      },

			// Ophalen record(s) via API
			getRecords() {
				let parg = {};
        parg.Params = {};

				this.listLoading = true;

				api.execute("list",parg).then((res) => {						
          util.processMainResults(res);
          
          if (util.getMainPayload("logs"))
          {
              this.content = util.getMainPayload("logs");
              this.mainTotal = this.content.length;
          }
          this.listLoading = false;
				})
        .catch((error) => {
          util.serverError(this);
        });

			},			

			getContent(file) {
				let parg = {};
        parg.Params = {};
        parg.Params.file = file;

				this.listLoading = true;

				api.execute("view",parg).then((res) => {						
          this.text = res.data.payload.content;
          this.listLoading = false;
				})
        .catch((error) => {
          util.serverError(this);
        });
			},			

      
			// Verwijder
			handleDel: function (row) {
				this.$confirm(text.getText("sdelM",this.mainSubject,row[this.mainKeyDesc]), 'Confirm', {
					type: 'warning',title: text.getText("sdelT",this.mainSubject)
				}).then(() => {
   				let parg = {};
          parg.Params = {};
          parg.Params.file = row.name;

			  	this.listLoading = true;

				  api.execute("del",parg).then((res) => {						
            this.listLoading = false;
            this.getRecords();
	  			})
          .catch((error) => {
            util.serverError(this);
          });

				}).catch(() => {

				});
			},
			
			// Display bewerkingsinterface
			handleView: function (row) {
        this.editMode = "view";        
        this.editTitle = text.getText("modM",this.mainSubject,row[this.mainKey]);
				this.editFormVisible = true;        
        this.getContent(row.name);
        
        this.editForm = Object.assign({}, row);
        //this.$nextTick(() => this.$refs.firstEdit.focus());
			},

		},

		mounted() {
      
      window.addEventListener("popstate", (event) => {
        this.closeForm();
      });

      if (this.$route.params) {
        this.stack = this.$route.params;
      }
      
			this.getRecords();
		}
	}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// xlog.vue?55442f76